import Customer from "../../../../Models/Customer";
import AutoCompleteTile from "./AutoCompleteTile";

export default class AutoCompleteCustomer {
	customers: Array<Customer>;
	customerInput: HTMLInputElement;
	currentFocus: number;

	constructor(customersList: Array<Customer>, input: HTMLInputElement) {
		this.customers = customersList;
		this.customerInput = input;
		this.currentFocus = -1;

		this.init();
	}

	private init() {
		this.customerInput.onkeydown = (event: KeyboardEvent) => {
			this.selectCustomer(event);
		}

		if (!this.customerInput.value) {
			return false;
		}

		const resultsWrapper = document.createElement("div");
		resultsWrapper.setAttribute("id", "autocomplete-list");
		resultsWrapper.setAttribute("class", "autocomplete-items");
		this.customerInput.parentNode.appendChild(resultsWrapper);

		this.customers.forEach(customer => {
			new AutoCompleteTile(customer, resultsWrapper, this.customerInput.value);
		});
	}

	private selectCustomer(event: KeyboardEvent) {
		const divContainer: HTMLDivElement = document.querySelector(`#autocomplete-list`);
		let collectionResult: HTMLCollectionOf<HTMLDivElement>;
		if (divContainer) {
			collectionResult = divContainer.getElementsByTagName("div");
		}

		if (event.keyCode == 40) { //arrow DOWN
			this.currentFocus++;
			this.addActive(collectionResult);
		} else if (event.keyCode == 38) { //arrow UP
			this.currentFocus--;
			this.addActive(collectionResult);
		} else if (event.keyCode == 13) { //ENTER key
			event.preventDefault();
			if (this.currentFocus > -1) {
				if (collectionResult) {
					const click = new Event("click");
					collectionResult[this.currentFocus].dispatchEvent(click);
				}
			}
		}
	}

	private addActive(elements: HTMLCollectionOf<HTMLDivElement>) {
		if (!elements) {
			return false;
		}

		this.removeActive(elements);

		if (this.currentFocus >= elements.length) {
			this.currentFocus = 0;
		}
		if (this.currentFocus < 0) {
			this.currentFocus = (elements.length - 1);
		}

		elements[this.currentFocus].classList.add("autocomplete-active");
	}

	private removeActive(elements: HTMLCollectionOf<HTMLDivElement>) {
		for (let i = 0; i < elements.length; i++) {
			elements[i].classList.remove("autocomplete-active");
		}
	}
}
